import styled from "styled-components";

export const VideoContainer = styled.div`
  width: calc(100% - 64px);
  margin-top: 40px;

  .video-window {
    aspect-ratio: 16 / 9;
    width: 100%;
  }
`;

export const Frame = styled.iframe`
  border: none;
  border-radius: 4px;
`;
